import {
  SET_RELATIONSHIP_DATA,
  CHANGE_REFETCH_STATUS,
  RESET_RELATIONSHIP_DATA,
  APPEND_RELATIONSHIP_LANE_DATA,
} from './relationshipTypes';

let columns = [
  { id: 'lane1', title: 'prospects', cards: [], label: '' },
  { id: 'lane2', title: 'reached out', cards: [], label: '' },
  { id: 'lane3', title: 'in conversation', cards: [], label: '' },
  { id: 'lane4', title: 'onboarded', cards: [], label: '' },
  { id: 'lane5', title: 'rejected', cards: [], label: '' },
];

const initialState = {
  columnData: { lanes: columns },
  refetch: true,
};

const relationshipReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RELATIONSHIP_DATA:
      const data = action.payload.data.lanes.map((col) => {
        const cards = col.cards.sort((a, b) => a.rv_order - b.rv_order);
        return { ...col, cards: cards, label: cards.length.toString() };
      });
      return { ...state, columnData: { lanes: data } };
    case APPEND_RELATIONSHIP_LANE_DATA: {
      const foundLane = state.columnData.lanes.find((l) => l.id === action.payload.laneId);
      foundLane.cards.push(
        ...action.payload.data.map((d) => ({
          ...d,
          laneId: action.payload.laneId,
        }))
      );
      return { ...state, columnData: { lanes: state.columnData.lanes } };
    }
    case CHANGE_REFETCH_STATUS:
      return { ...state, refetch: action.payload };
    case RESET_RELATIONSHIP_DATA:
      return { ...state, columnData: { lanes: columns } };
    default:
      return { ...state };
  }
};

export default relationshipReducer;
